<template>
    <div>
        <h3>拍手する・感想を送る</h3>
        <div>
            <p>
                貸し本棚に備わる数少ない交流の機能として、読者が作品へ拍手したり、感想を送る機能があります。
                この拍手と感想は、<b>送った読者と送られた作者にしか見えません。</b>
                他の読者に見えません。DMのような機能ですが、作者は１回しか返信できません。<br>
                感想を送るには、作者が該当の小説に「感想可の拍手ボタン」を設置していなければなりません。
                また、自分自身の小説に感想を送ることで、どのように表示されるか確認することができます。
            </p>

            <h4>拍手する</h4>
            <img src="/img/help/read/03.png" alt="拍手ボタン" class="img-thumbnail mb-3">
            <p>
                エピソードの最後に拍手ボタンが設置されていた場合、クリック・タップすることで拍手することができます。
                拍手ボタンは何回でもクリックできますが、同一ユーザーでカウントされるのは１回です。
                他の読者の拍手は見えません。
            </p>
            <p>
                グレーの拍手ボタンであれば拍手だけできますが、水色の拍手ボタンの場合は感想欄が表示されます。
            </p>
            <p>
                拍手したボタンは<i class="far fa-thumbs-up"></i>アイコンが表示されますが、
                セッションが消えるとクリアされます。
                これは登録ユーザーでも、匿名ユーザーでも同じです。
            </p>

            <h4>感想を書く</h4>
            <img src="/img/help/read/04.png" alt="感想欄" class="img-thumbnail mb-3">
            <p>
                感想が送信できる拍手ボタンが設置されている場合、拍手ボタンをクリックすることで、感想欄が表示されます。
                ここに感想を書き込んで送信することができます。
            </p>
            <p>
                自分自身が送信した感想は、送信直後は再度拍手ボタンをクリックすることで確認することができます。
                但し、登録ユーザーでない場合の感想は、見えなくなることがあります。
                <b>これは作者が感想を削除したわけではなく、非登録ユーザーのセッションが更新されたことが原因です。</b>
                もし、送信した感想を失いたくない場合は、ユーザー登録をお勧めします。
            </p>
            <h4>不適切な書き込み</h4>
            <p>
                以下のような書き込みはご遠慮ください。
            </p>
            <ol>
                <li>作者や作品への誹謗中傷</li>
                <li>作品と無関係な投稿</li>
                <li>宣伝、勧誘など感想と無関係な内容</li>
                <li>自分の作品への感想の要求</li>
                <li><b>誤字、脱字、整合性ミス等の指摘</b></li>
            </ol>
            <p>
                現状、誤字レポートは機能として用意されておらず、また感想欄から誤字報告することも推奨しておりません。
                作品によってはかなり古いものもあり、作者が誤字レポートに対応する時間がない場合があります。
                また誤字報告には是非に関する議論があり、実装は検討中です。ご意見があれば頂けると参考になります。
            </p>
        </div>
    </div>
</template>

<style src="../help.scss" scoped lang="scss"></style>

<script>
export default {
    created() {
        this.useHead({
            title: "感想を送る | 貸し本棚ヘルプ",
            link: [
                {
                    rel: "canonical",
                    href: location.origin + location.pathname,
                    id: "canonical"
                }
            ]
        });
    }
}
</script>